__turbopack_context__.v({
  "active": "TopNavV2-module-scss-module__s2WhGG__active",
  "appDrawMenu": "TopNavV2-module-scss-module__s2WhGG__appDrawMenu",
  "appDrawMenuOption": "TopNavV2-module-scss-module__s2WhGG__appDrawMenuOption",
  "appDrawMenuOptionListWrapper": "TopNavV2-module-scss-module__s2WhGG__appDrawMenuOptionListWrapper",
  "authActions": "TopNavV2-module-scss-module__s2WhGG__authActions",
  "centerNav": "TopNavV2-module-scss-module__s2WhGG__centerNav",
  "darkHeroMain": "TopNavV2-module-scss-module__s2WhGG__darkHeroMain",
  "darkHeroMainScrolled": "TopNavV2-module-scss-module__s2WhGG__darkHeroMainScrolled",
  "downloadBanner": "TopNavV2-module-scss-module__s2WhGG__downloadBanner",
  "drawerActions": "TopNavV2-module-scss-module__s2WhGG__drawerActions",
  "drawerLink": "TopNavV2-module-scss-module__s2WhGG__drawerLink",
  "drawerLinkActive": "TopNavV2-module-scss-module__s2WhGG__drawerLinkActive",
  "drawerLoginBtn": "TopNavV2-module-scss-module__s2WhGG__drawerLoginBtn",
  "drawerSignUpBtn": "TopNavV2-module-scss-module__s2WhGG__drawerSignUpBtn",
  "hamburgerMenu": "TopNavV2-module-scss-module__s2WhGG__hamburgerMenu",
  "hpv2Blink": "TopNavV2-module-scss-module__s2WhGG__hpv2Blink",
  "hpv2DemoBounce": "TopNavV2-module-scss-module__s2WhGG__hpv2DemoBounce",
  "hpv2DemoFadeIn": "TopNavV2-module-scss-module__s2WhGG__hpv2DemoFadeIn",
  "hpv2DemoProgress": "TopNavV2-module-scss-module__s2WhGG__hpv2DemoProgress",
  "hpv2DemoScaleIn": "TopNavV2-module-scss-module__s2WhGG__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "TopNavV2-module-scss-module__s2WhGG__hpv2DemoSlideIn",
  "hpv2FadeLeft": "TopNavV2-module-scss-module__s2WhGG__hpv2FadeLeft",
  "hpv2FadeRight": "TopNavV2-module-scss-module__s2WhGG__hpv2FadeRight",
  "hpv2FadeUp": "TopNavV2-module-scss-module__s2WhGG__hpv2FadeUp",
  "hpv2FloatA": "TopNavV2-module-scss-module__s2WhGG__hpv2FloatA",
  "hpv2FloatB": "TopNavV2-module-scss-module__s2WhGG__hpv2FloatB",
  "hpv2HeroFadeIn": "TopNavV2-module-scss-module__s2WhGG__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "TopNavV2-module-scss-module__s2WhGG__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "TopNavV2-module-scss-module__s2WhGG__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "TopNavV2-module-scss-module__s2WhGG__hpv2PriceShimmer",
  "hpv2PulseDot": "TopNavV2-module-scss-module__s2WhGG__hpv2PulseDot",
  "hpv2ScaleUp": "TopNavV2-module-scss-module__s2WhGG__hpv2ScaleUp",
  "inner": "TopNavV2-module-scss-module__s2WhGG__inner",
  "isOpen": "TopNavV2-module-scss-module__s2WhGG__isOpen",
  "langIconWrapper": "TopNavV2-module-scss-module__s2WhGG__langIconWrapper",
  "languageDropdown": "TopNavV2-module-scss-module__s2WhGG__languageDropdown",
  "languageDropdownContainer": "TopNavV2-module-scss-module__s2WhGG__languageDropdownContainer",
  "languageDropdownToggle": "TopNavV2-module-scss-module__s2WhGG__languageDropdownToggle",
  "languageSubmenu": "TopNavV2-module-scss-module__s2WhGG__languageSubmenu",
  "languageSubmenuWrapper": "TopNavV2-module-scss-module__s2WhGG__languageSubmenuWrapper",
  "left": "TopNavV2-module-scss-module__s2WhGG__left",
  "loginBtn": "TopNavV2-module-scss-module__s2WhGG__loginBtn",
  "logoText": "TopNavV2-module-scss-module__s2WhGG__logoText",
  "logoWrapper": "TopNavV2-module-scss-module__s2WhGG__logoWrapper",
  "main": "TopNavV2-module-scss-module__s2WhGG__main",
  "mobileLoginBtn": "TopNavV2-module-scss-module__s2WhGG__mobileLoginBtn",
  "navLink": "TopNavV2-module-scss-module__s2WhGG__navLink",
  "navLinkActive": "TopNavV2-module-scss-module__s2WhGG__navLinkActive",
  "open": "TopNavV2-module-scss-module__s2WhGG__open",
  "profileSlot": "TopNavV2-module-scss-module__s2WhGG__profileSlot",
  "right": "TopNavV2-module-scss-module__s2WhGG__right",
});
